// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2Z1Y5","buttons":"RemoveExpirationActionButtons_buttons__Rc09M"};